import { Button } from "antd"
import { useLocation, useNavigate } from "react-router-dom";
import { isIOS } from "react-device-detect";
import Success from '../../../../assets/images/lottie/success.json';
import Lottie from "lottie-react";
import { finishedProgramRequest } from "../../../../utils/gtm";


const WellnessProgramBookConfirm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location?.state;
    const onClickNavigate = () => {
        if (!state) return;
        finishedProgramRequest(state.title, state.ticketName, state.quantity, state.price, state.date, state.startTime);
        navigate(`/program/book/detail/${state.programBookingId}`, { replace: true });
    }

    return <>
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            textAlign: 'center'
        }}>
            <div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Lottie
                        style={{ width: 100, height: 100 }}
                        animationData={Success}
                        loop={false}
                        autoplay={true}
                    />
                </div>
                <div className="sub-title/st4" style={{ marginTop: 8 }}>
                    예약 신청이 완료되었습니다.
                </div>
                <div className="body/b3 secondary/s700" style={{ marginTop: 8 }}>예약이 확정되면 카카오 알림톡을 보내드립니다.
                    {state?.isPaid !== false &&
                        <>
                            <br />
                            확정 후 결제를 진행해주세요.
                        </>}
                </div>
            </div>
        </div>
        <div style={{ margin: 20, paddingTop: '20px', position: 'absolute', bottom: '0px', width: 'calc(100% - 40px)', maxWidth: '440px', marginBottom: isIOS ? 46 : 20 }}>
            <Button
                color="default"
                variant="solid"
                className="sub-title/st3 base/white"
                style={{ width: '100%', height: '51px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}
                onClick={onClickNavigate}>
                예약 내역 확인
            </Button>
        </div>
    </>
}

export default WellnessProgramBookConfirm